export enum PreferredCorrespondence {
  EMAIL = '0',
  POST = '1',
  PHONE = '2',
}

export enum PreferredContactTime {
  AM = '0',
  PM = '1',
}

export enum MarketingPreference {
  Telephone = '0',
  Email = '1',
  None = '2',
}

export enum EmploymentStatus {
  Employed = '0',
  Unemployed = '1',
  SelfEmployed = '2',
  Student = '3',
  Homemaker = '4',
  Retired = '5',
  Other = '6',
}

export enum AnnualIncome {
  '£0 - £24,999' = '0',
  '£25,000 - £49,999' = '1',
  '£50,000 - £74,999' = '2',
  '£75,000 - £149,999' = '3',
  '£150,000 - £299,999' = '4',
  '£300,000 +' = '5',
}

export enum InterestInstructions {
  AddedToAccount = 'AddedToAccount',
  PaidToAnotherAccount = 'PaidToAnotherChorleyAccount',
  PaidToBankAccount = 'PaidToABankAccount',
}

export enum CorrespondenceAddress {
  Applicant1 = 'Applicant1Address',
  Applicant2 = 'Applicant2Address',
  Other = 'Other',
}

interface AccountHolder {
  existingCustomer: boolean;
  title: {
    value: string;
    otherValue: string;
  };

  firstName: string;
  lastName: string;
  contactNumber: string;
  alternativeContactNumber: string;
  emailAddress: string;
  nationality: string;
  countryOfBirth: string;
  dateOfBirth: string;
  currentAddress: {
    line1: string;
    line2?: string;
    city: string;
    county: string;
    postcode: string;
    country: string;
  };
  preferredCorrespondence: PreferredCorrespondence;
  preferredContactTime: PreferredContactTime;
  usCitizen: { value: boolean; usTaxIdentificationNumber?: string };
  taxOtherUK: { value: boolean; details?: string };

  employmentStatus: {
    employmentStatus: EmploymentStatus;
    occupation: string;
    annualIncome: AnnualIncome;
    seniorPositionDetails: {
      value: boolean;
      details?: string;
    };
  };
}

export interface FormType {
  withdrawalSignatures: number;
  accountOpeningDetails: {
    investmentAmount: string;
    intendedDepositAmount: string;
    initialDepositSource: string;
    intendedAccountPurpose: string;
    jointAccountDetails: {
      accountHoldersRelationship: string;
      withdrawalSignatures: number | string;
      correspondenceAddress: {
        value: CorrespondenceAddress;
        otherAddress: {
          line1: string;
          line2?: string;
          city: string;
          county: string;
          postcode: string;
          country: string;
        } | null;
      };
    } | null;
    applyToOpenAccount: boolean;
  };
  accountHolderPersonalDetails: AccountHolder;
  secondAccountHolderPersonalDetails: AccountHolder;
  interestRequirement: {
    interestInstructions: {
      value: string;
      chorleyAccountNumber?: string;
      bank: {
        nameOfAccountHolder: string;
        name: string;
        currentAddress: string;
        postcode: string;
        sortcode: string;
        accountNumber: string;
      } | null;
    };
    declare: {
      a: boolean;
      b: boolean;
      c: boolean;
      d: boolean;
      e: boolean;
      f: boolean;
      g: boolean;
      h: boolean;
      i: boolean;
      j: boolean;
      k: boolean;
      l: boolean;
    };
  };
  personalInformation: {
    applicant1MarketingPreference: string;
    applicant2MarketingPreference: string;
    isPersonalAccountTransfer: boolean;
    wantsToBeContactedByPGMutual: boolean;
  };
}
